<template>
  <ol class="pl-0 list-none" :style="{ counterReset: 'item' }">
    <li
      v-for="item in items"
      :key="item"
      :class="[
        'mb-5',
        'flex',
        'items-center',
        'before:inline-block',
        'before:text-center',
        'before:w-32',
        'before:h-32',
        'before:min-w-32',
        'before:min-h-32',
        'before:bg-surface-secondary',
        'before:text-text-on-highlight',
        'before:font-medium',
        'before:rounded-xs',
        'before:mr-10',
        'before:leading-30 lg:before:leading-34',
        'before:text-16 md:before:text-18 lg:before:text-20',
        'before:content-[counter(item)]',
      ]"
      :style="{ counterIncrement: 'item' }"
    >
      <slot :item="item"></slot>
    </li>
  </ol>
</template>

<script lang="ts" setup>
defineProps<{
  items: string[];
}>();
</script>

<style lang="scss" scoped></style>
